export default __webpack_public_path__ + "static/media/avatar_69.a3b947f8.png";